import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";

export default function WebDetail() {
	return (
		<ServiceDetailLayout
			title="Développement Web"
			summarySections={[
				{ id: "intro", label: "Introduction" },
				{ id: "pourquoi", label: "Pourquoi un site web ?" },
				{ id: "avantages", label: "Bénéfices pour votre activité" },
				{ id: "fonctionnalites", label: "Fonctionnalités clés" },
				{ id: "securite", label: "Sécurité & RGPD" },
				{ id: "accompagnement", label: "Accompagnement & support" },
				{ id: "process", label: "Notre Processus" },
				{ id: "faq", label: "FAQ" }
			]}
		>
			<section id="intro">
				<h2>Introduction</h2>
				<p>
					Nous créons des sites web modernes, performants et adaptés à vos besoins métier. Notre équipe vous accompagne de la conception à la mise en ligne.
				</p>
			</section>
			<section id="pourquoi">
				<h2>Pourquoi un site web&nbsp;?</h2>
				<ul>
					<li>Visibilité accrue et crédibilité</li>
					<li>Acquisition de nouveaux clients</li>
					<li>Automatisation de processus métier</li>
				</ul>
			</section>
			<section id="avantages">
				<h2>Bénéfices pour votre activité</h2>
				<ul>
					<li>Design responsive et sur-mesure</li>
					<li>Optimisation SEO et performance</li>
					<li>Maintenance, évolutivité et analytics</li>
				</ul>
			</section>
			<section id="fonctionnalites">
				<h2>Fonctionnalités clés</h2>
				<ul>
					<li>Gestion de contenu, blog, e-commerce</li>
					<li>Formulaires avancés, espace client, paiement en ligne</li>
					<li>Intégration API, CRM, newsletter</li>
				</ul>
			</section>
			<section id="securite">
				<h2>Sécurité & RGPD</h2>
				<p>
					Hébergement sécurisé, sauvegardes, conformité RGPD, protection contre les attaques courantes.
				</p>
			</section>
			<section id="accompagnement">
				<h2>Accompagnement & support</h2>
				<ul>
					<li>Conseil et cadrage projet</li>
					<li>Formation de vos équipes</li>
					<li>Support technique réactif</li>
				</ul>
			</section>
			<section id="process">
				<h2>Notre Processus</h2>
				<ol>
					<li>Analyse et conseil</li>
					<li>Maquettage et validation</li>
					<li>Développement</li>
					<li>Recette et mise en ligne</li>
				</ol>
			</section>
			<section id="faq">
				<h2>FAQ</h2>
				<p style={{marginTop: '1.5rem', fontStyle: 'italic', color: '#6b21a8'}}>
					Une question spécifique&nbsp;? <b>Contactez-nous</b> pour un conseil personnalisé ou un devis gratuit, nous vous répondrons rapidement.
				</p>
			</section>
		</ServiceDetailLayout>
	);
}
